<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th class="wd-lg-200" style="width: 20%">
              <label class="ckbox mg-b-0 d-inline-block valign-middle">
                <input
                  type="checkbox"
                  :checked="isAll"
                  @change="changeAllCheck($event)"
                />
                <span></span>
              </label>
              {{ $t("order.订单号") }}/{{ $t("order.客户系统订单号") }}
            </th>
            <th class="wd-lg-200" style="width: 30%">
              {{ $t("order.发票编号") }}
            </th>
            <th class="wd-lg-150" style="width: 15%">
              {{ $t("order.经销商") }}
            </th>
            <th class="wd-lg-100" style="width: 20%">
              {{ $t("order.创建日期") }}
            </th>
            <th class="wd-lg-100" style="width: 15%">{{ $t("order.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id" :id="item.id">
            <td class="valign-middle tx-12">
              <div
                class="media d-flex align-items-center pos-relative"
                style="white-space: nowrap"
              >
                <label class="ckbox mg-b-0 d-inline-block valign-middle">
                  <input type="checkbox" :value="item.id" v-model="checkArr" />
                  <span></span>
                </label>
                <div>
                  <p class="mg-b-0">
                    {{ item.code ? item.code : "---" }}/{{
                      item.codeErp ? item.codeErp : "---"
                    }}
                  </p>
                </div>
              </div>
            </td>
            <td class="valign-middle tx-14">
              <p class="mg-b-0 tx-white">
                <span class="tx-white">{{ item.invoiceNumber }}</span>
              </p>
            </td>
            <td class="valign-middle tx-14">
              <p class="mg-b-0 tx-white">
                <span class="tx-white">{{ item.distributorName }}</span>
              </p>
            </td>
            <td class="valign-middle tx-12">
              <div>
                <span class="tx-white">{{
                  item.timeCreated | formatDate
                }}</span>
              </div>
            </td>
            <td>
              <a class="tx-info" :href="item.url" target="_blank">{{
                $t("app.下载")
              }}</a>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="5">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("order.没有符合条件的发票记录") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items", "checkArrs"],
  data() {
    return {
      checkArr: [],
    };
  },
  computed: {
    isAll() {
      return this.checkArr.length == this.items.length && this.items.length > 0
        ? true
        : false;
    },
  },
  watch: {
    checkArrs() {
      this.checkArr = this.checkArrs;
    },
    checkArr() {
      this.$parent.checkArrs = this.checkArr;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) return "----";
      return moment(val, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD");
    },
  },
  methods: {
    /**
     * 全选
     */
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.id);
        });
      }
    },
  },
};
</script>
